import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import CloseIcon from '@mui/icons-material/Close'
import Navigation from 'Components/Navigation'
import MiniLoading from 'Components/MiniLoading'
import './IframePageTemplate.css'
import { ROUTES, TRACKING_IFRAME_SANDBOX } from 'Utils/constants'

export default function IframePageTemplate({
  title,
  iframeUrl,
  loading = false,
}) {
  const history = useHistory()
  const [iframeLoaded, setIframeLoaded] = useState(false)

  const isPageLoading = loading || !iframeLoaded

  return (
    <>
      <Navigation />
      <div className="installation_service_request">
        <div className="floating-close-icon">
          <CloseIcon
            fontSize="inherit"
            onClick={() => history.replace(ROUTES.home)}
          />
        </div>

        {title && (
          <div className="installation_service_request_header">
            <h1 className="installation_service_request_title">{title}</h1>
          </div>
        )}

        {isPageLoading && (
          <MiniLoading
            full={true}
            noMargin={true}
            style={{ marginTop: '-113px' }}
          />
        )}

        {!loading && (
          <div
            className="iframe-tracking-container"
            style={{ display: iframeLoaded ? 'block' : 'none' }}>
            <iframe
              src={iframeUrl}
              className="iframe-tracking-element"
              title={title}
              sandbox={TRACKING_IFRAME_SANDBOX}
              onLoad={() => setIframeLoaded(true)}
            />
          </div>
        )}
      </div>
    </>
  )
}

IframePageTemplate.propTypes = {
  title: PropTypes.string,
  iframeUrl: PropTypes.string.isRequired,
  loading: PropTypes.bool,
}
